import PAApi from './_paApi.js';
import httpClient from '@/apis/base/httpclient';

class PAStatisticalDayOffAPI extends PAApi {
  constructor() {
    super();
  }
  controllerName = 'PaWorkPoints';

  /**
   * Hàm kiểm tra dữ liệu đã được sử dụng cho bảng lương chưa
   * @param {*} records
   * @returns
   * dqvinh 27.10.2022
   */
  async checkDataUseSalary(records) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/checkDataUseSalary',
      data: records,
    };

    return await httpClient.postAsync(request);
  }
}

export default new PAStatisticalDayOffAPI();
